<template>
  <div class="flex_vh100 home">
    <div>
      <!-- 顶部导航 -->
      <van-nav-bar
        title="在线信息"
        left-text="返回"
        left-arrow
        @click-left="goBack"
      >
      </van-nav-bar>
    </div>
    <div class="content-area">
      <!-- 上半部分：统计数据 -->
      <div class="section">
        <div class="section-header">
          <span class="section-title">在线统计</span>
          <van-icon
            name="replay"
            size="20"
            color="#1989fa"
            @click="refreshStats"
          />
        </div>
        <div class="stats-list">
          <div class="stats-item" @click="goToStatsDetail(1)">
            <van-cell-group>
              <van-cell
                title="登录人次"
                :value="statsData.count1.count || 0"
                is-link
              />
              <van-cell title="用户/机器人最高在线">
                <template #default>
                  <span class="stats-inline"
                    >{{ statsData.count1.count2 || 0 }} /
                    {{ statsData.count1.count3 || 0 }}</span
                  >
                </template>
              </van-cell>
            </van-cell-group>
          </div>
          <div class="stats-item" @click="goToStatsDetail(2)">
            <van-cell-group>
              <van-cell
                title="注册人数"
                :value="statsData.count2.count || 0"
                is-link
              />
            </van-cell-group>
          </div>
          <div class="stats-item" @click="goToStatsDetail(3)">
            <van-cell-group>
              <van-cell
                title="充值金额"
                :value="(statsData.count3.count || 0) / 100"
                is-link
              />
            </van-cell-group>
          </div>
          <div class="stats-item" @click="goToStatsDetail(4)">
            <van-cell-group>
              <van-cell
                title="房卡消耗"
                :value="statsData.count4.count || 0"
                is-link
              />
            </van-cell-group>
          </div>
        </div>
      </div>

      <!-- 下半部分：在线服务器列表 -->
      <div class="section">
        <div class="section-header">
          <span class="section-title">在线服务器列表</span>
          <van-icon
            name="replay"
            size="20"
            color="#1989fa"
            @click="refreshServerList"
          />
        </div>
        <div class="server-list">
          <div
            v-for="item in serverList"
            :key="item.serverId"
            class="server-item"
          >
            <van-cell-group>
              <van-cell title="服务器ID" :value="item.serverId" />
              <van-cell title="服务器名称" :value="item.serverName" />
              <van-cell title="服务器IP" :value="item.serverListenIp" />
              <van-cell title="游戏房间" :value="item.roomeName" />
              <van-cell title="在线人数(真实/机器人)">
                <template #default>
                  <span
                    >{{ item.onlineCount }} /
                    {{ item.onlineCount_rabbit }}</span
                  >
                </template>
              </van-cell>
            </van-cell-group>
          </div>
          <van-empty v-if="serverList.length === 0" description="暂无数据" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import {
  GetPlatFormStatisticsDetails,
  GetPlatFormOnlineStatistics,
} from "../api/financeapi.js";

export default {
  name: "OnlineStatisics",
  data() {
    return {
      // 上半部分统计数据
      statsData: {
        count1: { count: 0, count2: 0, count3: 0 }, // 在线人数
        count2: { count: 0 }, // 注册人数
        count3: { count: 0 }, // 充值金额
        count4: { count: 0 }, // 房卡消耗
      },
      // 下半部分服务器列表
      serverList: [],
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },

    // 跳转到统计详情页
    goToStatsDetail(type) {
      this.$router.push({
        path: "/onlinestatisics/detail",
        query: { type },
      });
    },

    // 获取昨天日期字符串 YYYY-MM-DD 00:00:00
    getYesterday() {
      const d = new Date();
      d.setDate(d.getDate() - 1);
      const year = d.getFullYear();
      const month = (d.getMonth() + 1).toString().padStart(2, "0");
      const day = d.getDate().toString().padStart(2, "0");
      return `${year}-${month}-${day} 00:00:00`;
    },

    // 获取今天日期字符串 YYYY-MM-DD 00:00:00
    getToday() {
      const d = new Date();
      const year = d.getFullYear();
      const month = (d.getMonth() + 1).toString().padStart(2, "0");
      const day = d.getDate().toString().padStart(2, "0");
      return `${year}-${month}-${day} 00:00:00`;
    },

    // 查询平台统计详情
    _getPlatFormStatisticsDetails(params) {
      return GetPlatFormStatisticsDetails(params);
    },

    // 查询在线服务器列表
    _getPlatFormOnlineStatistics(params) {
      return GetPlatFormOnlineStatistics(params);
    },

    // 刷新上半部分统计数据
    refreshStats() {
      const startDate = this.getYesterday();
      const endDate = this.getToday();
      const types = [1, 2, 3, 4];

      Promise.all(
        types.map((type) =>
          this._getPlatFormStatisticsDetails({
            startDate,
            endDate,
            type,
          })
        )
      )
        .then((results) => {
          const [res1, res2, res3, res4] = results;
          this.statsData = {
            count1:
              res1.length > 0 ? res1[0] : { count: 0, count2: 0, count3: 0 },
            count2: res2.length > 0 ? res2[0] : { count: 0 },
            count3: res3.length > 0 ? res3[0] : { count: 0 },
            count4: res4.length > 0 ? res4[0] : { count: 0 },
          };
        })
        .catch(() => {
          Toast.fail("数据加载失败");
        });
    },

    // 刷新下半部分服务器列表
    refreshServerList() {
      this._getPlatFormOnlineStatistics({})
        .then((res) => {
          this.serverList = res || [];
        })
        .catch(() => {
          Toast.fail("数据加载失败");
        });
    },
  },
  mounted() {
    this.refreshStats();
    this.refreshServerList();
  },
};
</script>

<style scoped>
.content-area {
  flex: 1;
  overflow-y: auto;
  padding: 10px;
  background-color: #f5f6f8;
}

.section {
  margin-bottom: 12px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.section-title {
  font-size: 15px;
  font-weight: bold;
  color: #323233;
  padding: 15px 0;
}

.section-header .van-icon {
  cursor: pointer;
}

.stats-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.stats-item {
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
}

.stats-item :deep(.van-cell-group) {
  background-color: transparent;
}

.stats-item :deep(.van-cell-group::after) {
  display: none;
}

.stats-item :deep(.van-cell) {
  padding: 8px 12px;
  font-size: 13px;
  line-height: 1.5;
  display: flex;
  align-items: center;
}

.stats-item :deep(.van-cell::after) {
  display: none;
}

.stats-item :deep(.van-cell__title) {
  color: #323233;
  font-size: 13px;
}

.stats-item :deep(.van-cell__value) {
  color: #969799;
  font-size: 13px;
}

.stats-inline {
  color: #969799;
  font-size: 13px;
}

.server-list {
  background-color: transparent;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.server-item {
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
}

.server-item:last-child {
  border-bottom: none;
}

.server-item :deep(.van-cell-group) {
  background-color: transparent;
}

.server-item :deep(.van-cell-group::after) {
  display: none;
}

.server-item :deep(.van-cell) {
  padding: 8px 12px;
  font-size: 13px;
  line-height: 1.5;
}

.server-item :deep(.van-cell::after) {
  display: none;
}

.server-item :deep(.van-cell__title) {
  color: #323233;
  font-size: 13px;
}

.server-item :deep(.van-cell__value) {
  color: #969799;
  font-size: 13px;
}
</style>
